import { GeneralSingleSignOnInfo } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { LinkButton } from '@optimus-web/core';

interface UnlockFormSsoProps {
    ssoData: GeneralSingleSignOnInfo | undefined | null;
}

export function UnlockFormSso({ ssoData }: UnlockFormSsoProps) {
    if (!ssoData || !ssoData.signInUrl) {
        return null;
    }

    return (
        <LinkButton href={ssoData.signInUrl} wide variant="primary">
            <LocalizedText textKey={TextKey.UnlockWithSso} />
        </LinkButton>
    );
}
